import { getDefaultConfigEn } from './en';
import { getDefaultConfigDe } from './de';
import { useLang } from 'utils/localisation';

export const useDefaultConfigs = type => {
  const lang = useLang();
  let defaultConfig = null;

  if (type) {
    if (lang === 'de') {
      defaultConfig = getDefaultConfigDe(type);
    } else {
      defaultConfig = getDefaultConfigEn(type);
    }
  }

  return defaultConfig;
};
